import { render, staticRenderFns } from "./StudentAbsenceRequestsSlidebar.vue?vue&type=template&id=421e6f69"
import script from "./StudentAbsenceRequestsSlidebar.vue?vue&type=script&lang=js"
export * from "./StudentAbsenceRequestsSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports